import {
  CheckIcon,
  GKButton,
  GKTextField,
  Grid2,
  PercentageIcon,
} from "components";
import { RevenueManagerDetails } from "interfaces/Revenue";
import { Controller, useForm } from "react-hook-form";
import { useUpdateRevenueSharingMutation } from "store/features/Revenue/FeePlan";
import { validationForPercentage } from "utils/helpers";

interface Props {
  feePlanDetails: RevenueManagerDetails;
  portfolioId: string;
  setOpen: (open: {
    open: boolean;
    type: string;
    modalTitle: string;
    width?: string;
    subTitle?: string;
  }) => void;
}

const RevenueSharingForm = (props: Props) => {
  const { feePlanDetails, portfolioId, setOpen } = props;

  const form = useForm({
    defaultValues: {
      managementFeeSharingPercentage:
        feePlanDetails?.partnerSharing?.managementFeeSharingPercentage || "0",
      performanceFeeSharingPercentage:
        feePlanDetails?.partnerSharing?.performanceFeeSharingPercentage || "0",
    },
  });

  const [updateRevenueSharing, { isLoading }] =
    useUpdateRevenueSharingMutation();

  return (
    <form
      onSubmit={form.handleSubmit(async (values) => {
        try {
          await updateRevenueSharing({ ...values, portfolioId }).unwrap();
          setOpen({
            open: false,
            modalTitle: "",
            type: "",
            subTitle: "",
            width: "",
          });
        } catch (error) {
          console.error("Error updating revenue sharing:", error);
        }
      })}
    >
      <Grid2 container spacing={3}>
        <Grid2 size={12}>
          <Controller
            control={form.control}
            name="managementFeeSharingPercentage"
            render={({ field }) => (
              <GKTextField
                {...field}
                inputLabel="Management Fees"
                type="number"
                onChange={(e) => {
                  field.onChange(
                    e.target?.value === ""
                      ? ""
                      : validationForPercentage(+e.target.value),
                  );
                }}
                slotProps={{ input: { endAdornment: <PercentageIcon /> } }}
              />
            )}
          />
        </Grid2>
        <Grid2 size={12}>
          <Controller
            control={form.control}
            name="performanceFeeSharingPercentage"
            render={({ field }) => (
              <GKTextField
                {...field}
                inputLabel="Performance Fees"
                type="number"
                onChange={(e) => {
                  field.onChange(
                    e.target?.value === ""
                      ? ""
                      : validationForPercentage(+e.target.value),
                  );
                }}
                slotProps={{ input: { endAdornment: <PercentageIcon /> } }}
              />
            )}
          />
        </Grid2>
        <Grid2 size={12} mt={2}>
          <GKButton
            fullWidth
            variant="contained"
            type="submit"
            startIcon={<CheckIcon />}
            loading={isLoading}
          >
            Save Changes
          </GKButton>
        </Grid2>
      </Grid2>
    </form>
  );
};

export default RevenueSharingForm;
